module.exports = __webpack_public_path__ + "img/icb-del-Adv-e@3x.3335f4fa.png";